import { types } from 'mobx-state-tree';

const MessageData = types.model('MessageData', {
  id: types.maybeNull(types.string),
  defaultMessage: types.string,
  forceRefresh: types.optional(types.boolean, false),
  isOpen: types.optional(types.boolean, false)
}).views((self) => {
  return {
    get isTranslatable() {
      return self.id?.length > 0;
    },
    get hasContent() {
      return self.defaultMessage.length > 0;
    },
  };
});

const UserMessage = types.optional(MessageData, {
  id: '',
  defaultMessage: '',
  forceRefresh: false,
});

export default UserMessage;
